// ---Third-party imports
import { get } from 'ldash';
// ---Framework imports
import log from 'uix/logging';
import { handleActions, handleAction, handleSubState } from 'uix/actions';
import { persistReducer } from 'uix/persist';
// ---Local imports
import { uploadFile, setUploadState, clearUploads } from './actions';
// ---Exports
const updateUploads = (uploads, fileid, data)=>({
        ...uploads,
        [fileid]: {
            ...get(uploads, fileid, {}),
            ...data
        }
    });
let uploadReducer = handleActions(new Map([
    [
        uploadFile,
        (data_imp, { payload })=>{
            let { fileid, bytes } = payload;
            let uploads = updateUploads(data_imp.uploads, fileid, {
                state: 'init'
            });
            return {
                ...data_imp,
                uploads
            };
        }
    ],
    [
        setUploadState,
        (data_imp, { payload })=>{
            let { fileid, ...rest } = payload;
            let uploads = updateUploads(data_imp.uploads, fileid, rest);
            return {
                ...data_imp,
                uploads
            };
        }
    ],
    [
        clearUploads,
        (data_imp)=>({
                ...data_imp,
                uploads: {}
            })
    ]
]), {
    uploads: {}
});
export const data = [
    handleSubState('upload', [
        persistReducer(uploadReducer, {
            key: 'uix_uploads',
            whitelist: [
                'uploads'
            ]
        })
    ])
];
